import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { store } from '~/app/store'
import { App } from './App'
import './styles/global.css'

// A data router, though every route is still declared in `App`: only a data router lets a
// screen block navigation away from unsaved work (`useBlocker`), sidebar links included.
const router = createBrowserRouter([{ path: '*', element: <App /> }])

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </StrictMode>,
)
